// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fNdg","colBig":"styles_colBig__1accB","colSmall":"styles_colSmall__1_mfe"};